import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

export default function Cobranca() {
  return (
    <div className="pt-28 font-sans text-foreground bg-gradient-to-b from-background via-[#0B0B15] to-[#0E0E1A] min-h-screen">
      {/* --- HERO SECTION --- */}
      <section className="container mx-auto px-6 lg:px-16 py-20 flex flex-col lg:flex-row items-center gap-16">
        {/* Texto */}
        <div className="flex-1 space-y-6">
          <h3 className="text-[#7C3AED] font-semibold tracking-wide uppercase">
            Cobrança
          </h3>
          <h1 className="text-4xl md:text-5xl font-bold leading-tight text-white">
            Automatize sua cobrança <br />
            <span className="text-[#A78BFA]">reduza a inadimplência</span>
          </h1>

          {/* Lista com ícones */}
          <ul className="space-y-4 text-base text-muted-foreground leading-relaxed">
            <li className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-[#7C3AED] flex-shrink-0 mt-0.5" />
              <span>
                Envie lembretes automáticos de pré-vencimento, vencimento e
                pós-vencimento sem depender da equipe.
              </span>
            </li>

            <li className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-[#7C3AED] flex-shrink-0 mt-0.5" />
              <span>
                Integre com seu ERP e envie boletos, faturas e valores
                atualizados diretamente para seus clientes.
              </span>
            </li>

            <li className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-[#7C3AED] flex-shrink-0 mt-0.5" />
              <span>
                Automatize confirmações de pagamento, solicitações de segunda
                via e respostas inteligentes, reduzindo a carga manual da equipe
                financeira.
              </span>
            </li>
          </ul>

          <div className="flex gap-4 pt-6">
            <Button
              asChild
              className="bg-gradient-to-r from-[#3e0969] to-[#7C3AED] text-white font-semibold rounded-full px-8 py-2 shadow-[0_0_18px_rgba(124,58,237,0.4)] hover:shadow-[0_0_25px_rgba(124,58,237,0.8)] transition-all duration-500"
            >
              <a href="https://flow.ascconecta.com.br/login" target="_blank" rel="noopener noreferrer">
                Começar agora
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              className="border-[#7C3AED70] text-[#7C3AED] font-semibold rounded-full px-8 py-2 hover:bg-[#7C3AED10] transition-all"
            >
              <a href="https://wa.me/5527996259361" target="_blank" rel="noopener noreferrer">
                Falar com vendas
              </a>
            </Button>
          </div>
        </div>

        {/* Imagem 1 (de public) */}
        <div className="flex-1 flex justify-center">
          <img
            src="/cobranca-flow1.png"
            alt="Fluxo de cobrança - visão 1"
            className="rounded-xl border border-[#7C3AED30] shadow-[0_0_25px_rgba(124,58,237,0.25)] w-full max-w-lg"
          />
        </div>
      </section>

      {/* --- INFO SECTION --- */}
      <section className="container mx-auto px-6 lg:px-16 py-24 flex flex-col lg:flex-row items-center gap-16 border-t border-border">
        {/* Texto */}
        <div className="flex-1 space-y-6">
          <h2 className="text-3xl md:text-4xl font-bold text-white">
            Como empresas usam o ASC Flow para{" "}
            <span className="text-[#A78BFA]">automatizar a cobrança</span>
          </h2>

          <div className="space-y-6 text-muted-foreground leading-relaxed">
            <div>
              <h4 className="font-semibold text-white mb-1">
                Régua automática de cobrança
              </h4>
              <p>
                Lembretes automáticos configurados de acordo com dias antes ou
                depois do vencimento, reduzindo esquecimentos e atrasos.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-white mb-1">
                Envios de boletos e faturas
              </h4>
              <p>
                Busque automaticamente boletos e faturas no sistema financeiro
                ou ERP e envie para os clientes sem intervenção manual.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-white mb-1">
                Confirmação de pagamento
              </h4>
              <p>
                Conecte ao retorno bancário e atualize pagamentos
                automaticamente, encerrando cobranças concluídas.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-white mb-1">
                Atendimento automatizado
              </h4>
              <p>
                Mensagens inteligentes para dúvidas comuns, como segunda via,
                valores, formas de pagamento e comprovantes.
              </p>
            </div>
          </div>
        </div>

        {/* Imagem 2 (de public) */}
        <div className="flex-1 flex justify-center">
          <img
            src="/cobranca-flow2.png"
            alt="Fluxo de cobrança - visão 2"
            className="rounded-xl border border-[#7C3AED30] shadow-[0_0_25px_rgba(124,58,237,0.25)] w-full max-w-lg"
          />
        </div>
      </section>
    </div>
  );
}
